import Box from "@mui/material/Box";

const IndonesiaFlag = () => {
    return (
        <Box
            sx={{
                width: 18,
                height: 12,
                borderRadius: "2px",
                overflow: "hidden",
                boxShadow: "0 0 0 1px rgba(0,0,0,0.2)",
            }}
        >
            <Box sx={{ width: "100%", height: "50%", bgcolor: "#ff0000" }} />
            <Box sx={{ width: "100%", height: "50%", bgcolor: "#ffffff" }} />
        </Box>
    )
}

export default IndonesiaFlag;
